import React, { useState } from "react";
import { LayoutGrid, Loader2 } from "lucide-react";
import { cvApi, cvErr } from "@/lib/vendorApi";

/** Platform cards a super admin granted this vendor — they open on the TEA desktop, which shows only these cards. */
export const PlatformTab = ({ cards }) => {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const open = async () => {
    setBusy(true); setErr("");
    try {
      const { token } = await cvApi.post("/desk", {});
      localStorage.setItem("nex_token", token);
      window.location.href = "/admin";
    } catch (e) { setErr(cvErr(e)); setBusy(false); }
  };
  return (
    <div className="space-y-4" data-testid="vendor-platform">
      <ul className="grid sm:grid-cols-2 gap-2">{cards.map((c) => (
        <li key={c.id} data-testid={`vendor-platform-card-${c.id}`} className="rounded-lg border border-white/10 bg-white/[0.03] px-4 py-3 flex items-center gap-3">
          <LayoutGrid className="h-4 w-4 text-[#d4a017]" /><span className="flex-1 text-sm">{c.label}</span>
          <span className="font-mono text-[10px] uppercase tracking-[0.14em] text-white/50">{c.level === "edit" ? "Can edit" : "Read only"}</span></li>))}</ul>
      {err && <p className="text-sm text-red-300" data-testid="vendor-platform-error">{err}</p>}
      <button type="button" onClick={open} disabled={busy} data-testid="vendor-platform-open"
        className="inline-flex items-center gap-2 rounded-full bg-[#d4a017] text-black px-5 py-2.5 text-sm font-semibold hover:bg-[#e6b52a] transition-colors disabled:opacity-60">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} Open my platform cards</button>
    </div>
  );
};
